<template lang="pug">
.cadastro-form-field
  label.cadastro-form-field__label(v-if="label")
    span {{ label }}
    span.cadastro-form-field__required(v-if="required") *
  slot
  span.cadastro-form-field__error(v-if="error") {{ error }}
</template>

<script>
export default {
  name: 'CadastroFormField',
  props: {
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.cadastro-form-field__label {
  align-items: center;
  color: #141414;
  display: flex;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
  font-weight: 500;
  gap: 4px;
  line-height: 1;
}

.cadastro-form-field__required {
  color: #ef4444;
}

.cadastro-form-field__error {
  color: #ef4444;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
}
</style>
